<template>
  <iframe name="iframe-webchat" id="iframe-webchat" style="position: fixed;right:0;height:85px; width:85px; margin: 10px 20px;transform: translateZ(0);z-index: 9998;bottom: 0;" frameborder=0></iframe>
</template>

<script>

export default {
  name: 'VollChat',
  created () {
    this.$loadScript('../../../../vollChat/bundle.js')
  }
}
</script>

<style scoped>

</style>
